import { Injectable } from '@angular/core';
import { HttpClient, HttpEventType, HttpHeaders } from '@angular/common/http';
import {MainService} from './main.service';

import {session} from '../../../environments/environment.session'
import { MakingDataService } from '../../md/service/making-data.service';
@Injectable({
  providedIn: 'root'
})

export class EventGroupService {

  httpUrl;
  constructor(private http: HttpClient, private main: MainService,private mds:MakingDataService) {
    this.httpUrl = this.main.httpUrl+"/accounts/eventgroup";
  }

  async geteventlist(obj:any) {
    const resp = await this.http.get<any>(this.httpUrl + '/geteventlist' + JSON.stringify({}) ,{ headers: new HttpHeaders().append('data', await this.mds.dataE(obj)) }).toPromise().then(res => {
      return res;
    });
    return resp;
  }
  async geteventByID(obj:any) {
    const resp = await this.http.get<any>(this.httpUrl + '/eventById' + obj).toPromise().then(res => {
      return res;
    });
    return resp;
  }


  async geteventxref(obj:any) {
    const resp = await this.http.get<any>(this.httpUrl + '/geteventxref' + obj).toPromise().then(res => { // event_group_xref_line
      return res;
    });
    return resp;
  }

  async rejectevent(obj:any){
    const res = await this.http.post<any>(this.httpUrl + '/rejectEvent',obj).toPromise().then(res => {
      return res;
    });
    return res;
  }


  async insertProcessedData(obj:any){

    const res = await this.http.post<any>(this.httpUrl + '/addProcessedData',obj).toPromise().then(res => {
      return res;
    });
    return res;
  }



}
